/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used for the jobs list on the Jobs screen.
 */
export const JOBS_LIST_DATA_IDS = {
  jobNameButton: 'Button: Job name',
  noJobsEmptyState: `Jobs list: No Jobs found`,
  noMatchingJobsEmptyState: `Jobs list: No matching Jobs found`,
  searchBar: 'Job search: Filter jobs',
};
